import InfoIcon from '@mui/icons-material/Info';
import { Pagination, Paper, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useEffect, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { activeDeactiveSellerFn, getSellersFn } from 'Services/Seller';
import StatusDropdown from './ChangeStatusSeller';
import AdditionalDeatil from './sellerAdditionModal';

const Seller = () => {
    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState("");
    const [totalPage, setTotalPage] = useState(1);

    const { data: getSellersResponse, refetch } = useQuery({
        queryKey: ['get-seller-list', search, page],
        queryFn: () => getSellersFn({ page, search }),
        enabled: (!!page || !search),
        refetchOnWindowFocus: false,
    });
    const getSellers = getSellersResponse?.data?.data;

    const { mutate } = useMutation(
        activeDeactiveSellerFn,
        {
            onSuccess: (response) => {
                if (response?.status === 200) {
                    toast.success("Status Updated");
                    refetch();
                }
            }
        }
    )

    const hanleEnableDisable = (id) => {
        const formData = new FormData();
        formData.append("seller_id", id);
        mutate(formData);
    }

    const handleChange = (event, value) => {
        setPage(value);
    };


    useEffect(() => {
        if (getSellersResponse?.data) {
            setTotalPage(getSellersResponse.data.total_pages || 1);
        }
    }, [getSellersResponse]);

    return (
        <div>
            <div className="p-2">
                <p className="text-xl !text-black font font-bold">
                    Sellers
                </p>
            </div>
            <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
                <div className="flex items-center justify-between my-2">
                    <span className="flex gap-3">
                        <input
                            className="placeholder:italic placeholder:text-slate-400 block mx-3 bg-white w-80 border border-slate-300 rounded-md py-2 px-2 pr-3 shadow-sm focus:outline-none focus:border-slate-600 focus:ring-slate-500 focus:ring-1 sm:text-sm"
                            placeholder="Search for anything..."
                            type="text"
                            name="search"
                            value={search}
                            onChange={(event) => setSearch(event.target.value)}
                        />
                    </span>
                </div>
            </div>
            <TableContainer
                component={Paper}
                sx={{ width: "100%", maxHeight: 440 }}
                className="!text-black !mx-auto !bg-white overflow-auto px-2"
            >
                <Table stickyHeader aria-label="sticky table" size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }} className="!text-center !text-gray-800 !font-bold">
                                ID
                            </TableCell>
                            <TableCell style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }} className="!text-center !text-gray-800 !font-bold">
                                Company
                            </TableCell>
                            <TableCell style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }} className="!text-center !text-gray-800 !font-bold">
                                Contact Person
                            </TableCell>
                            <TableCell style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }} className="!text-center !text-gray-800 !font-bold">
                                Primary Email
                            </TableCell>
                            <TableCell style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }} className="!text-center !text-gray-800 !font-bold">
                                Primary Mobile
                            </TableCell>
                            <TableCell style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }} className="!text-center !text-gray-800 !font-bold">
                                City
                            </TableCell>
                            <TableCell style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }} className="!text-center !text-gray-800 !font-bold">
                                State
                            </TableCell>
                            <TableCell style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }} className="!text-center !text-gray-800 !font-bold">
                                Country
                            </TableCell>
                            <TableCell style={{ fontFamily: "'Poppins', sans-serif" }} className="!text-center !text-gray-800 !font-bold">
                                Active Status
                            </TableCell>
                            <TableCell style={{ fontFamily: "'Poppins', sans-serif" }} className="!text-center !text-gray-800 !font-bold">
                                Status
                            </TableCell>
                            <TableCell style={{ fontFamily: "'Poppins', sans-serif" }} className="!text-center !text-gray-800 !font-bold">
                                Account Type
                            </TableCell>
                            <TableCell style={{ fontFamily: "'Poppins', sans-serif" }} className="!text-center !text-gray-800 !font-bold">
                                More Info
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {getSellers?.map((row, index) => (
                            <TableRow key={row?.id} className="!text-slate-700">
                                <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                                    {row?.id}
                                </TableCell>
                                <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                                    {row?.company || "--"}
                                </TableCell>
                                <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                                    {row?.contact_person || "--"}
                                </TableCell>
                                <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                                    {row?.primary_email || "--"}
                                </TableCell>
                                <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                                    {row?.primary_mobile || "--"}
                                </TableCell>
                                <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                                    {row?.city || "--"}
                                </TableCell>
                                <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                                    {row?.state || "--"}
                                </TableCell>
                                <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                                    {row?.country || "--"}
                                </TableCell>


                                <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                                    <StatusDropdown initialStatus={row?.status} id={row?.id} />
                                </TableCell>
                                <TableCell className="!text-center !text-[12px]" style={{ fontFamily: "'Poppins', sans-serif" }}>
                                    <Switch
                                        color="success"
                                        checked={row?.active_status}
                                        onChange={() => hanleEnableDisable(row?.id)}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                    />
                                </TableCell>

                                <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                                    <AdditionalDeatil data={row} />
                                </TableCell>
                                <TableCell className="!text-center !text-[12px]" style={{ fontFamily: "'Poppins', sans-serif" }}>
                                    <InfoIcon
                                        className='text-2xl text-yellow-700 mx-auto cursor-pointer'
                                        onClick={() => navigate(`/seller/${row?.id}`)}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <div className="flex justify-center p-2">
                <Pagination
                    page={page}
                    size="small"
                    count={totalPage}
                    variant="outlined"
                    color="primary"
                    onChange={handleChange}
                />
            </div>
        </div>
    )
}

export default Seller;